import { render } from "./pageBtn.vue?vue&type=template&id=60b21682&scoped=true&ts=true"
import script from "./pageBtn.vue?vue&type=script&lang=ts"
export * from "./pageBtn.vue?vue&type=script&lang=ts"

import "./pageBtn.vue?vue&type=style&index=0&id=60b21682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b21682"]])

export default __exports__